import { render, staticRenderFns } from "./return.vue?vue&type=template&id=6747dcc4&scoped=true&"
import script from "./return.vue?vue&type=script&lang=ts&"
export * from "./return.vue?vue&type=script&lang=ts&"
import style0 from "./return.vue?vue&type=style&index=0&id=6747dcc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747dcc4",
  null
  
)

export default component.exports